var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25085 14.1128L5.25031 0.607025C5.25042 0.271723 5.50773 0 5.82517 0C6.14258 0 6.39992 0.271723 6.4 0.607025L6.39992 14.11L10.4286 9.85559C10.6531 9.61858 11.017 9.61858 11.2414 9.85559C11.4659 10.0926 11.4659 10.4769 11.2414 10.7141L6.23163 16.0046C6.11898 16.1228 5.97181 16.1826 5.82478 16.1826C5.73009 16.1826 5.63536 16.1581 5.55008 16.109C5.50184 16.0815 5.45654 16.0462 5.41587 16.003L0.406612 10.7141C0.182171 10.4769 0.182171 10.0926 0.406612 9.85559C0.631053 9.61858 0.99498 9.61858 1.21956 9.85559L5.25085 14.1128Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.ebaa970b8842728a96540a817250d51e.svg";
export { ForwardRef as ReactComponent };